import { createContext, useContext, useEffect, useState } from "react";
import { getUserURL, userLoginURL } from "../utils/ConstantsURL";

export const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("There is no auth provider available");
  }
  return context;
};

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => JSON.parse(sessionStorage.getItem("tkn")));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = async (email, password) => {
    try {
      const response = await fetch(userLoginURL(), {
        method: "POST",
        body: JSON.stringify({ email, password }),
        headers: { "Content-Type": "application/json" },
      });

      const data = await response.json();

      if (response.ok && data.token) {
        setToken(data.token);
        sessionStorage.setItem("tkn", JSON.stringify(data.token));
      }

      return data;
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      throw error;
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    sessionStorage.removeItem("tkn");
  };

  const fetchUser = async (activeToken) => {
    setLoading(true);
    try {
      const response = await fetch(getUserURL(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeToken}`,
        },
      });

      const data = await response.json();

      if (response.ok && data.user) {
        setUser(data.user);
      } else {
        console.warn("Token inválido o expirado");
        logout();
      }
    } catch (error) {
      console.error("Error al obtener el usuario:", error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUser(token);
    } else {
      setLoading(false);
    }
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthContext.Provider value={{ token, user, login, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
}